import { translationsEn } from "./en";
import { translationsFr } from "./fr";
const translations = { fr: {...translationsFr}, en: {...translationsEn} }
export {translations}